import { useEffect, useState } from "react";
import { Star, Quote } from "lucide-react";
import { api } from "@/lib/site";
import { STATIC_REVIEWS } from "@/lib/staticData";
import "@/components/marquee.css";

function ReviewCard({ r }) {
  return (
    <div className="w-[340px] md:w-[380px] shrink-0 bg-white rounded-2xl p-6 border border-gray-100 shadow-sm mx-3" data-testid="marquee-review-card">
      <div className="flex items-center justify-between mb-3">
        <div className="flex gap-1 text-gold">
          {Array.from({ length: r.rating || 5 }).map((_, j) => <Star key={j} size={14} fill="currentColor" />)}
        </div>
        <Quote className="text-gold/30" size={22} />
      </div>
      <p className="text-gray-700 text-sm leading-relaxed line-clamp-5 italic">"{r.message}"</p>
      <div className="mt-4 flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-royal text-white font-bold flex items-center justify-center">
          {r.name?.charAt(0)}
        </div>
        <div>
          <p className="font-bold text-royal text-sm">{r.name}</p>
          <p className="text-[11px] text-gray-500">{r.role}</p>
        </div>
      </div>
    </div>
  );
}

export default function ReviewsMarquee() {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    api.get("/reviews")
      .then((r) => setReviews(r.data))
      .catch(() => setReviews(STATIC_REVIEWS));
  }, []);

  if (reviews.length === 0) return null;

  // Duplicate the list for seamless loop
  const doubled = [...reviews, ...reviews];

  return (
    <section className="py-20 bg-white overflow-hidden" data-testid="reviews-marquee">
      <div className="max-w-7xl mx-auto px-6 text-center mb-12">
        <span className="inline-block bg-gold/15 text-gold-dark px-5 py-1.5 rounded-full text-xs font-bold tracking-[0.25em]">TESTIMONIALS</span>
        <h2 className="font-serif-display text-4xl md:text-5xl font-bold mt-6 text-royal">What Parents Say</h2>
        <div className="w-16 h-1 bg-gold mx-auto mt-4 rounded-full" />
      </div>

      <div className="marquee-mask">
        <div className="marquee-track">
          {doubled.map((r, i) => <ReviewCard key={`${r.id}-${i}`} r={r} />)}
        </div>
      </div>

      <div className="marquee-mask mt-6 [--dir:reverse]">
        <div className="marquee-track" style={{ animationDirection: "reverse", animationDuration: "55s" }}>
          {doubled.slice().reverse().map((r, i) => <ReviewCard key={`r-${r.id}-${i}`} r={r} />)}
        </div>
      </div>
    </section>
  );
}
